var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.7 0h26.6v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.8 0 14 7.5 24 0h3.3v2.6l-10 7.4 10 7.5V20H24l-10-7.5L4 20H.7v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18.3 11.7 9 6.6V20L16 11.7zm-7.6.8.2 1.5-8 6H.7zM27.3 0v.1L17 8V6l8.3-6zM.7 0l10 7.3H8L.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.7 0v20h6.7V0zM.7 6.7v6.6h26.6V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.7 8v4h26.6V8zM12 0v20h4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.8 21q-1.1 1-1.5 2.3-.7 3.3-2.1 2.3c0 1.3 1 1.3 1.5.6q0 1.8 1.4 3 .5.5.3-.3c-.2-.3-.2-1.6-.6-2.4.6.5 1.5.2 1.4-1q-1.3.9-1.6-.6a6 6 0 0 1 1.2-3.9Zm-.9-9q.1-.8-.4-1.2-1-.7-1.7 0c-.7-.3-1 1-1.8.8q.1.6.7.4c-.4.4 0 .9-.5 1.3q1.4.3 1.3-1a1 1 0 0 0 1.2 0q-.7-.4-.3-1c.3-.6 1.6-.6 1.5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36 18.5c-1 .5-2.9.3-3-1s1-1.9 1.4-2c.5-.3 1 .2.8.7.6-.2.7-.9.4-1.3q1.3 0 1.8-1.3-.6.1-1.6 0 .3-.4.1-.8c-.6.7-1.5.4-2.8 2.3L34 12c.1-1.3-1.2-1.3-1.5-.7q.3.4 0 1.3l-.6 3c-.1-.8-.7-1-.8-1.3q-.3.2-.2.6c-.2-.2-1 0-1.2-.3-.3.6.2 1.1.6 1.4l-.6.3q.6.7 1.3.7t1.1.8c.5 1 2.3 1.6 4 .7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.5 17.4a5 5 0 0 1-2.9 2.8c-1.1.3-3.6 1.5-4.2 2h-.3c-.3-.3-.6-1 0-1.6 1.8-1.7 3.7-1 4.9-2-1 .4-2.9.2-3-1a5 5 0 0 0 4.5-1.4q.6.4 1 1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.8 21c-.8.8-1.3 2.6-1.2 3.9q0 .6.3.7c0-.7.5-2.5 1.8-3.4a9 9 0 0 0 3.3-4q0-.5-.6-.8c-.6 1.7-2.3 2.5-3.6 3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#316d3a",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.9 16.6q-.7 1-1.8 1.4.3-.2.2-.5-1.6.4-3.3 0a5 5 0 0 0 4.5-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M31.1 20.6c-1.4 1.3-.5 2.5.1 2.8-.2.9.7.8.7 1.6q.6-.5.4-1.2c.5.5 1.6 0 1.8.8.2-1-.6-2-1.5-1.9q.4-.6-.2-1c-.1.7-1 .7-1.3.4q-.6-.4 0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.2 29.1q-.1.2 0 .4c.2.3-.2 1 .5 1q.3 0 .4-.2c.2-.6-.5-.7-.5-1q0-.3-.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.8 30.2q-.4 0-.3 1c0 .2 0 1-.3 1l.6-.1q.4.3.6-.1.2.1.3-.3.3.2.3-.4.3 0 .5-.2c-.2 0-.9-.3-1-.6q-.3-.4-.7-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m31.5 11.2.3-.4m3.3 3q.2-.2.7-.2m-1 18.5v-.7m.6.6-.4-.6m.7.3-.5-.7m.8.3-.8-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.7 20.6c2.3 2 2.5 3.5 2.1 4.4-.2-.9-1.1-2.2-2.1-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.6 19.5h4.3v5a9 9 0 0 1-4.9 8.3 9 9 0 0 1-4.8-8.2v-5.1h3q0 .5.3 1 1.2-.1 2-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006ec7",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.9 19.5v5q0 2-.6 3.5L40 20.2 35.8 28q-.6-1.5-.6-3.4v-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "m44.4 27.7-.3.8-4.1-7.6-4 7.6-.4-.8 4.4-8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m42 30.4.4.2q.3-.7.1-1.6c-.2.6-1 .6-1.2 1l.3.2-1.3.9v-5.7q0-.3-.3-.4-.3.1-.2.4V31c-.3-.5-1.1-.3-1.5-1h.5c-.3-1-1-1-1.2-1.3 0 .4-.2 1.4 0 1.8l.3-.3c.3.7 1.8.7 2.1 1.9.3-.4 1.3-1 2-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40 27h1.7l.2-.3q0-.4-.2-.4h-3.4l-.2.4.2.3zm-.2-1.6h-.2q-.4 0-.4.3t.3.4.4-.4q.1-.3.3 0 0 .5-.7.6-.5 0-.6-.6t.6-.6l.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "m38.3 27 .2-.3-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.3 27 .2-.3-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "m38.5 27 .1-.3-.1-.4m.9.7.2-.3-.2-.4m.2.8.2-.4q0-.4-.2-.4m.7.8.2-.4q0-.4-.2-.4m.2.8q.3 0 .3-.4t-.3-.4m1 .7.2-.3-.1-.4m-3.7 4 .4-.2Zm4 .1q.4-.4.6-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.5 27 .1-.3-.1-.4m.9.7.2-.3-.2-.4m.2.8.2-.4q0-.4-.2-.4m.7.8.2-.4q0-.4-.2-.4m.2.8q.3 0 .3-.4t-.3-.4m1 .7.2-.3-.1-.4m-3.7 4 .4-.2m3.4.2v-.1m.2.2q.4-.4.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m39.2 23.1.1-.2.3-.1h1.3v1.8h-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m39.2 23.1.1-.2.3-.1h1.3v1.8h-1.7v-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m40.5 24.8.2-.1.1-.2v-1.6h-1.4l-.2.2v1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.6 24.8h-1.4V23h1.3l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43 18.5q.3.4.2 1h-.4q.3-.7-.5-1c-1 0-2.1 1.8-3.8 2-.5-.5-.5-1.6.2-2.2q-.4-1.3-1.5-2.3l-.9-.1q.6-.8 1.5-1.3l.3-.4c0-.7 3.5-.4 4.2 0 0 .9.4 3.6.7 4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.8 19q-.1-1.9-1.3-3a2 2 0 0 0 1.5-.2c.6-.4 2.3-1.2 2.9-.8v.4c-.1-.3-1.7.3-2.1.4q-.7.3-.5 1l-.4-.5.2 1q-.1-.4-.6-1 .6 1.4.4 2.8.6 0 1-.4-.4.5-1 .6-.3.4-.3 1c0-.4 0-1.2.2-1.3m4.2-.5q-.5-.5-1.6-.3l.5-.2-.2-1.2.2-.1.3 1.3.4.1-.4-1.8.3-.1q0 1.2.5 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.8 19.5q.3-.7-.5-1-.7.1-1.7 1zm-4.1-4q-.7 0-1.3-.2l.1-.2-.7.5c.5.1 1.4.2 1.9-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.7 18.3.1.9m-1-4.6-.4.7 1.3.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.2 16h.3q.7.2 1.5-.2c.5-.4 1.8-1.4 3.2-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.8 15.6c.5.1 1.4.2 1.9-.1q1.5-1.1 3.2-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M44.7 20.6q2.5 1.4 3 3.8.6 2.5 1.9 1.7c-.2 1-1.2 1.1-2 .4 0 1-.4 2.4-1.6 3 0-.7.4-1.3.3-1.8q-.1-.5.2-1.1c-.6.2-1.6-.2-1.7-1.1.7.3 1.7.4 2-.5s.2-2.5-2-4.4Zm2-8.8c.5-1.3 1.8-1.1 2.2-.6 1.3-.7 1.4.9 2.5.6q-.1.6-.8.5c.4.4-.1 1 .7 1.3-.7.4-1.8 0-2-1-.3.5-1.2.5-1.5 0 .7-.1.7-.8.3-1.1q-1-.4-1.4.3Zm-3.8 2.8q.6 1.6 1.9 3c.9.8 2.2.5 3-.2 0 1.5-1.6 1.6-2.5 1.2q-.8-.4-.4.2 1 .8 3.4 1.2c2.6.6 1.7 2.7.9 2.7q.5 0 0-.6c-2.2-2-6.8-1.2-6.8-5.8-.4 1.2-2.5.7-1.5-.7q.6.5 1-.1.1-.5-.5-1.2l.2-.3q0 .4.5.3 0 .2.3.2v-.2q.1.3.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 18.6q1.6 1.2 3.4-.7.7-.6 1.3-.8l.7-.5-.5-.2c.7-.2.5-.8.8-1-.3 0-.7-.4-1.1.1q0-.4-.2-.6c0 .3-.5.3-.6 1q-.1.6-.4-.2c0-.5-.2-1.7-.5-2.4s-.3-1.5 0-1.6l-.1-.2q-1-.4-1.4.3c-.5 1.3.9 2 .8 3.4-.2-1-2-1.3-1.9-2.3q-.7.4-.2 1c-.4-.5-1.2.4-1.8-.3-.1 1 .7 1.3 1.4 1.3q-.3 1 .6 1.3c0-1 2.1-.6 2.2 1.2 0 1.5-1.7 1.6-2.5 1.2Zm3 1.4c2.6.6 1.7 2.7.9 2.7q-.9-.2-1-.8-.7.6 0 1.1-1.7 0-1.7 1.5c.2-.4.9-.4 1.1-.3.3 0 1 .1 1.2-.2-.2.2.1.6-.2 1 1-.1 1.4-1 1.3-1.4 1.2-1.2 1-3.1-1.6-3.6Zm-2 9q.1.1 0 .4c-.2.3.1 1-.6 1.1q-.4 0-.4-.3c-.2-.7.5-.7.6-1q0-.5.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.6 30.2q.5 0 .3 1c0 .3 0 1 .3 1q-.4.4-.7 0-.4.4-.6-.1-.4 0-.4-.3-.3.1-.3-.5-.4 0-.5-.2c.2 0 1-.4 1-.7q.5-.4 1-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.5 32.3v-.9m-.6.7.4-.6m-.8.3q.4-.3.6-.8m-1 .3q.5-.1 1-.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.4 16.3q.1 2.9 2 3.6c-.5-.3-.3-1.1-.9-1.4h.7q-.2-.6-1-.9h.7c-.3-.5-1.2-.3-1.5-1.3Zm-.2-1.8-.1-.2q-.5 0-.5-.2 0 .3-.2.2.7.8.5 1.2-.4.6-1 .1c0 .8 1 1 1.4 0l.2.5q.3-.8-.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.6 10.7Q40 10 39.9 9c0-.4.2-.9.8-.7-.2 0 0 .4-.2.4l.4-.1.3.2-.2-.5q.2-.1.1-.5l-.2.4q0-.4-.3-.6v.5q-.4 0-.7.3 0-.5.2-.9 0-.2-.2 0-.3-.5-.9-.3-.4 0-.6.2c-.2.2-.8.3-.8.6l-.1.5q-.1.4.2.7c0-.8 1-2.1 2.2-1.6l-.2 1q-.1 1 .6 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41 8.4q0-.3.6-.4c.5 0 .8.5 1.2.4q.4 0 .1.3v.2q0 .2-.2 0c-.4-.1-.7.2-1.2 0q-.5-.1-.6-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39 12.9q-.4-1-1.3-1.4v-.3l.9-.7c1.4.7 3.3-.3 4.2-1.2l.3.1-.2.3-.1-.1-1.3 1.2.9.1 1.7-1.1.3.3-.3.2-.1-.1a9 9 0 0 0-2.2 3.2c-.5-.1-2.4 0-2.8-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m41.5 10.8-.3-.1q-.4.3-1 .3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39 12.7q0-1.2.5-1.8a3 3 0 0 0 2.9 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m39 12.3 2.3.1q.6 0 .8.4m-2.8-.6.2-.2-.2-.2-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.8 8.7q-.6-.5-1 0 0 .3-.3.5v.4q0 .3.3.7 0-.3.6-.5.6 0 .7-.6c0-.2.2-.4-.4-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.4 11.4v.5h.1l.5-.2-.5.3.5.3-.5-.2v.6h-.1V12l-.5.3.4-.3-.4-.2v-.1l.5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#96877d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39 12.7a.9.9 0 1 1 .1-1.2v.5a.6.6 0 1 0-.7.6q.5 0 .6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38 13.5v-.4l.2.2v-.5l.4.3v-.4l.3.3.1-.6.3.3q0-.2.3-.3l.2.5.2-.2.1.3.3-.3.2.3v-.4l.2.3.2-.4.2.5.2-.3v.4l.3-.2v.2l.3-.4.2.4.4-.3v.4l.1-.2v.4l.3-.1-.3.6q-1.5-.3-4.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    d: "m41.2 8.5.4-.2 1 .2q.2 0 0 .1v.1h-1q-.4 0-.4-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7e017",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.3 14q-.4.5-.6.1l.1-.5q0-.3.2-.2c.1.1.4-.2.5.1q.3.5.2.6t-.4 0Zm1.3-.4q0-.4.4-.2c.1.1.3-.2.5 0l.2.6q-.2.3-.5.1h-.5zm2 .1c-.2-.1.2-.3.4 0q.2-.3.4.1v.6q0 .2-.3-.1-.5 0-.5-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#337321",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.5 13.5s.3-.3.5-.1l.5.1q.4.6.2.7l-.4-.1h-.4q-.3-.2-.4-.6Zm2 0q.1-.2.6 0l.4.2v.5h-.3l-.5-.2zm1.9.3q0-.2.3 0c0 .2.4 0 .4.4l-.1.4q-.3 0-.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.3 14s-.2-.3-.4 0m1.4 0-.2-.2m1.1.3L40 14m.1-.3q.3 0 .4.3l.2.2m.5 0-.1-.2m0-.4.1.3m.8.5-.2-.3m.2-.2.4.5m.3-.5v.3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPn);
export default __webpack_public_path__ + "static/media/pn.6cb10c46bbb4f8459e577f725c217027.svg";
export { ForwardRef as ReactComponent };